function getCssVar(name) {
  if (typeof document === 'undefined') {
    return '';
  }
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

function mergeAxisTitle(themeTitleStyle, userTitle) {
  if (userTitle === false) {
    return false;
  }
  if (typeof userTitle === 'string') {
    return { text: userTitle, style: { ...themeTitleStyle } };
  }
  if (userTitle && typeof userTitle === 'object') {
    return {
      ...userTitle,
      style: { ...themeTitleStyle, ...userTitle.style },
    };
  }
  return { style: { ...themeTitleStyle } };
}

function mergeSingleAxis(themeAxis, userAxis) {
  return {
    ...themeAxis,
    ...userAxis,
    labels: {
      ...themeAxis.labels,
      ...userAxis.labels,
      style: { ...themeAxis.labels?.style, ...userAxis.labels?.style },
    },
    title: mergeAxisTitle(themeAxis.title?.style, userAxis.title),
  };
}

function mergeAxis(themeAxis, userAxis) {
  if (!userAxis) {
    return themeAxis;
  }
  if (Array.isArray(userAxis)) {
    return userAxis.map(axis => mergeSingleAxis(themeAxis, axis));
  }
  return mergeSingleAxis(themeAxis, userAxis);
}

export function getHighchartsTheme() {
  const textColor = getCssVar('--color-text');
  const mutedColor = getCssVar('--color-muted');
  const bgColor = getCssVar('--color-bg-soft');
  const borderColor = getCssVar('--border-color');

  return {
    chart: {
      backgroundColor: bgColor,
    },
    title: {
      style: {
        color: textColor,
      },
    },
    subtitle: {
      style: {
        color: mutedColor,
      },
    },
    xAxis: {
      labels: {
        style: {
          color: textColor,
        },
      },
      lineColor: borderColor,
      tickColor: borderColor,
      title: {
        style: {
          color: textColor,
        },
      },
    },
    yAxis: {
      labels: {
        style: {
          color: textColor,
        },
      },
      gridLineColor: borderColor,
      title: {
        style: {
          color: textColor,
        },
      },
    },
    tooltip: {
      backgroundColor: bgColor,
      borderColor: borderColor,
      style: {
        color: textColor,
      },
    },
  };
}

export function applyHighchartsTheme(options) {
  const theme = getHighchartsTheme();

  return {
    ...options,
    chart: { ...theme.chart, ...options.chart },
    title: {
      ...theme.title,
      ...options.title,
      style: { ...theme.title.style, ...options.title?.style },
    },
    subtitle: {
      ...theme.subtitle,
      ...options.subtitle,
      style: { ...theme.subtitle.style, ...options.subtitle?.style },
    },
    xAxis: mergeAxis(theme.xAxis, options.xAxis),
    yAxis: mergeAxis(theme.yAxis, options.yAxis),
    tooltip: {
      ...theme.tooltip,
      ...options.tooltip,
      style: { ...theme.tooltip.style, ...options.tooltip?.style },
    },
  };
}
